import { useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "./PageTransition";
import { useState } from "react";
import { NavLink, Link, Outlet } from "react-router-dom";
import TexchemeLogo from "./TexchemeLogo";

const PAGE_NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/products", label: "Products" },
  { to: "/tools", label: "Tools" },
  { to: "/about", label: "About" },
  { to: "/team", label: "Team" },
  { to: "/coverage", label: "Coverage" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Layout({ company, openQuote, outletContext }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  function handleQuote() {
    setMobileOpen(false);
    openQuote("topbar");
  }

  function closeMobile() {
    setMobileOpen(false);
  }

  return (
    <div className="tex-app" data-testid="tex-app">
      <div className="topbar" data-testid="topbar">
        <div className="topbar-inner wrap">
          <Link to="/" className="brand" data-testid="brand" onClick={closeMobile}>
            <TexchemeLogo variant="reverse" size={30} />
          </Link>

          <nav className="tabs desktop-nav" data-testid="nav-tabs">
            {PAGE_NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => (isActive ? "on" : "")}
                data-testid={`nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="topbar-actions">
            <button
              className="btn btn-brand btn-sm"
              onClick={handleQuote}
              data-testid="topbar-request-quote"
            >
              Request a quote
            </button>
            <button
              className="mobile-nav-toggle"
              aria-label="Toggle menu"
              onClick={() => setMobileOpen((v) => !v)}
              data-testid="mobile-nav-toggle"
            >
              {mobileOpen ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="mobile-nav" data-testid="mobile-nav">
            {PAGE_NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => (isActive ? "on" : "")}
                onClick={closeMobile}
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>

      <AnimatePresence mode="wait">
        <PageTransition key={location.pathname}>
          <Outlet context={outletContext} />
        </PageTransition>
      </AnimatePresence>

      <footer className="tex-footer" data-testid="footer">
        <div className="wrap footer-grid">
          <div>
            <div style={{ marginBottom: 12 }}>
              <TexchemeLogo variant="reverse" size={28} />
            </div>
            <p style={{ fontSize: 15, color: "rgba(255,255,255,.9)", fontWeight: 500 }}>
              Your Chemicals. Our Delivery.
            </p>
            <p className="note">{company?.certifications_note}</p>
          </div>
          <div>
            <h4>Company</h4>
            <p><Link to="/about" className="footer-link">About us</Link></p>
            <p><Link to="/products" className="footer-link">Products</Link></p>
            <p><Link to="/team" className="footer-link">Our team</Link></p>
            <p><Link to="/coverage" className="footer-link">Where we serve</Link></p>
            <p><Link to="/faq" className="footer-link">FAQs</Link></p>
          </div>
          <div>
            <h4>Get in touch</h4>
            <p><Link to="/contact" className="footer-link">Contact us</Link></p>
            <p>{company?.quote_email}</p>
            <p>{company?.phone}</p>
            <p className="note">{company?.hours}</p>
          </div>
        </div>
        <div className="wrap footer-bottom">
          <span>© {new Date().getFullYear()} {company?.name || "Texcheme"}. Bulk chemical supply for industrial India.</span>
          <span>Guardian-Sage. Honesty over hype.</span>
        </div>
      </footer>
    </div>
  );
}

